
Greenmile.Survey = Greenmile.Survey || {};

Greenmile.Survey.Widgets = {

    formAlertError: function () {

        var divError = document.createElement("div");
        divError.setAttribute('class', 'monetInlineAlerContainer');


        return divError;
    },

    getSection: function () {
        var sectionId = new Date().getTime().toString(),
            section   = this.getSectionToQuestions(sectionId);

        return section;
    },

    getSectionToQuestions: function (sectionId, sectionTitleValue = '') {
        const name = `survey_section_title_${sectionId}`;
        const sectionTitleFieldProps = {
          name,
          label: '',
          placeholder: Monet.I18n.getResourcesByKey("Survey.filter.txt.questionTitle"),
          type: 'TEXT',
        };
        const sectionTitleField = new Monet.UI.Fields.Render(sectionTitleFieldProps, 'Survey').render();
        const questionLabelTitle = document.createElement('label');
        const divTrash = document.createElement('div');

        questionLabelTitle.innerHTML = Monet.I18n.getResourcesByKey("Survey.filter.txt.questionTitle");

        sectionTitleField.field = sectionTitleFieldProps;
        sectionTitleField.input.className = `.autocomplete_${name}`;
        sectionTitleField.setValue(sectionTitleValue);

        divTrash.setAttribute('class', 'destroyGroup');
        divTrash.addEventListener('click', function () {

            const isToDelete = () => {
                let questionWidget = this.parentNode;
                let sectionID = null;

                while (sectionID === null) {
                    questionWidget = questionWidget.parentNode;
                    sectionID = questionWidget.getAttribute('section_id');
                }

                for (var i = 0, size = Greenmile.Survey.Data.surveyData.length; i < size; i++) {
                    const section = Greenmile.Survey.Data.surveyData[i];
                    if (sectionID.toString() === section.id.toString()) {
                        Greenmile.Survey.Edit.deleteSurveySection(sectionID);
                        Greenmile.Survey.Data.surveyData.splice(i, 1);
                        break;
                    }
                }

                const parent = questionWidget.parentNode;
                parent.removeChild(questionWidget);
                Greenmile.Survey.Form.verifyQuestionsToEnableActionButton();
            };

            new Greenmile.Components.AlertModal('Greenmile.Survey.Confirm.DeleteItem',
                null,
                isToDelete)
            .show();
        });

        var questionHeader = document.createElement('div');
        questionHeader.className = "questionHeader";
        questionHeader.appendChild(questionLabelTitle);
        questionHeader.appendChild(sectionTitleField.rootEl);
        questionHeader.appendChild(divTrash);

        new Greenmile.Components.AddAttribute(
          sectionTitleField, [
          'order.number',
          'stop.location.description',
          'order.plannedSize1',
          'order.plannedSize2',
          'order.plannedSize3',
          'order.actualSize1',
          'order.actualSize2',
          'order.actualSize3',
          'order.plannedPickupSize1',
          'order.plannedPickupSize2',
          'order.plannedPickupSize3',
          'order.actualPickupSize1',
          'order.actualPickupSize2',
          'order.actualPickupSize3',
          'order.size1AliasConfig.key',
          'order.size2AliasConfig.key',
          'order.size3AliasConfig.key',
          'order.totalPrice'
        ]).render()

        var newQuestion = Greenmile.Survey.Widgets.newQuestionWidget();

        var questionGroupContent = document.createElement('div');
        questionGroupContent.className = 'questionGroupContent';

        var questionGroup = document.createElement('div');
        questionGroup.className = "questionGroup";
        questionGroup.setAttribute('section_id', sectionId);

        questionGroup.appendChild(questionHeader);
        questionGroup.appendChild(newQuestion);
        questionGroup.appendChild(questionGroupContent);

        if (Greenmile.Survey.Builder.releasedDate) {

            divTrash.style.display = 'none';
            newQuestion.style.display = 'none';
            const button = questionHeader.querySelector('.btn.dropdown-toggle')
            if (button) {
              button.setAttribute('disabled', true);
            }
        }

        return questionGroup;
    },

    showModalToQuestion: function (target, parentQuestionId) {
        var questionWidget = target.parentNode,
            sectionID      = null;

        while (sectionID === null) {
            questionWidget = questionWidget.parentNode;
            sectionID = questionWidget.getAttribute('section_id');
        }

        Greenmile.Survey.Form.showOverlayForSection(sectionID, parentQuestionId);
    },

    newQuestionWidget: function () {
        var btnQuestion = document.createElement("input");
        btnQuestion.type = "button";
        btnQuestion.value = Monet.I18n.getResourcesByKey("Survey.form.btn.questionButton");
        btnQuestion.name = "btn_question";
        btnQuestion.className = "btn i18nResource question addItem";

        btnQuestion.addEventListener('click', function (e) {
            this.showModalToQuestion(e.target);
        }.bind(this));

        var separator = document.createElement('div');
        separator.className = "lineSeparator";

        var sectionGroup = document.createElement("div");
        sectionGroup.className = "sectionGroup";

        sectionGroup.appendChild(btnQuestion);
        sectionGroup.appendChild(separator);

        return sectionGroup;
    },

    getNewQuestionContent: function (parentQuestionId) {

        var questionId = new Date().getTime().toString(),
            question   = this.questionContentWidget({ id: questionId }, parentQuestionId);

        return question;

    },

    questionContentWidget: function (question, parentQuestionId) {
        var questionId = question.id;
        var questionDescription = document.createElement('div');
        questionDescription.className = 'newQuestionDescription';

        var mandatory = new Monet.UI.Fields.Render({
            type: 'CHECKBOX',
            name: 'isMandatory-'+questionId,
            label: 'Greenmile.Survey.Question.Mandatory'
        }, 'Survey').render();

        let requirePhoto = new Monet.UI.Fields.Render({
            type: 'CHECKBOX',
            name: 'requirePhoto-'+questionId,
            label: 'Greenmile.Survey.Question.RequirePhoto'
        }, 'Survey').render();

        var finalCheck = new Monet.UI.Fields.Render({
            type: 'CHECKBOX',
            name: 'isFinal-'+questionId,
            label: 'Greenmile.Survey.Question.Final'
        }, 'Survey').render();

        var loopCheck = new Monet.UI.Fields.Render({
            type: 'CHECKBOX',
            name: 'isLoop-'+questionId,
            label: 'Greenmile.Survey.Question.Loop'
        }, 'Survey').render();

        var buttonConf = new Monet.UI.Fields.Button();
        buttonConf.render();
        buttonConf.setId();
        buttonConf.rootEl.className = 'btnConfigs';
        buttonConf.rootEl.setAttribute('question_id', questionId);

        var questionHeader = document.createElement('div');
        var answerContent = document.createElement('div');
        var separator = document.createElement('div');
        var questionContent = document.createElement('div');

        questionHeader.className = 'newQuestionHeader';
        answerContent.className = 'answerContent';
        separator.className = "lineSeparator";
        questionContent.className = 'newQuestionContent';
        questionContent.setAttribute('question_id', questionId);


        if (Greenmile.Survey.Builder.releasedDate) {

            buttonConf.rootEl.style.display = 'none';
        }

        if (parentQuestionId) {
            questionContent.appendChild(separator);
        }

        mandatory.setValue(question.mandatory);
        requirePhoto.setValue(question.requirePhoto);
        finalCheck.setValue(question.finishSurvey);

        questionHeader.appendChild(questionDescription);
        questionHeader.appendChild(mandatory.rootEl);
        questionHeader.appendChild(requirePhoto.rootEl);
        questionContent.appendChild(questionHeader);
        questionContent.appendChild(answerContent);

        if (!parentQuestionId) {

            questionHeader.appendChild(finalCheck.rootEl);
            loopCheck.setValue(question.loopQuestion);
            questionHeader.appendChild(loopCheck.rootEl);

            var buttonAddSubQuestions = this.getAddSubQuestionButton(questionId);
            var subQuestionContent = document.createElement('div');
            subQuestionContent.className = 'subQuestionContent';
            subQuestionContent.appendChild(buttonAddSubQuestions.rootEl);
            subQuestionContent.setAttribute('question_id', questionId);
            questionContent.appendChild(subQuestionContent);
            questionContent.appendChild(separator);
        }

        questionHeader.appendChild(buttonConf.rootEl);

        return questionContent;
    },

    getOptionsToQuestionField: function (fieldValue) {
        const { surveyData } = Greenmile.Survey.Data;
        const empty = { value: '', description: Monet.I18n.getResourcesByKey('Survey.generateTask.condition.selectQuestion') };
        const questionOptions = [];

        if (surveyData?.length) {
            questionOptions.push(empty);
            surveyData.forEach((section) => {
                section.surveyQuestions.forEach((question) => {
                    if (Greenmile.Survey.Data.isSurveyQuestionAllowed(question.id, fieldValue) || question.id === fieldValue) {
                        const labelSection = (section.title && section.title !== "") ? section.title : section.order;
                        const labelQuestion = (question.question && question.question !== "") ? question.question : question.order;
                        questionOptions.push({
                            value: question.id,
                            description: Monet.I18n.translateResources(
                                "Survey.generateTask.condition.selectQuestion.optionLabels",
                                { sessionOrder: labelSection, questionOrder: labelQuestion }
                            )
                        });
                    }
                });
            });
        }

        return questionOptions;
    },

    actionWidgetCondition: function({ id, type, parent, actionId, condition }) {
        const actionWidgetConditionLabel = document.createElement('label');

        const warningMessage = document.createElement('div');

        const textDomains = [
            { value: '', description: Monet.I18n.getResourcesByKey('Survey.generateTask.condition.selectCondition')},
            { value: 'TEXT_EMPTY', description: Monet.I18n.getResourcesByKey('Survey.generateTask.condition.textEmpty') },
        ];
        const pickListDomains = [
            { value: '', description: Monet.I18n.getResourcesByKey('Survey.generateTask.condition.selectCondition')},
            { value: 'ALL_OPTIONS_CHECKED', description: Monet.I18n.getResourcesByKey('Survey.generateTask.condition.allOptionsChecked') },
            { value: 'SOME_OPTIONS_CHECKED', description: Monet.I18n.getResourcesByKey('Survey.generateTask.condition.someOptionsChecked') },
        ];

        const getResourceByType = (resType) => {
            const resources = {
                AND: 'Survey.generateTask.condition.labelAnd',
                DEFAULT: 'Survey.generateTask.condition.labelIf'
            };

            return resources[resType] || resources['DEFAULT'];
        };

        actionWidgetConditionLabel.innerHTML = Monet.I18n.getResourcesByKey(getResourceByType(type));
        warningMessage.innerHTML = Monet.I18n.getResourcesByKey('Survey.generateTask.condition.warning');
        warningMessage.setAttribute('class', 'conditionWarningMessage');

        const selectQuestionField = new Monet.UI.Fields.PickList();
        selectQuestionField.createElement();
        selectQuestionField.setData(this.getOptionsToQuestionField(condition?.questionId));

        const selectConditionField = new Monet.UI.Fields.PickList();
        selectConditionField.createElement();
        selectConditionField.hide();

        const questionFieldEl = selectQuestionField.rootEl.querySelector('.pickListField');
        questionFieldEl.classList.add("questionField");
        const selectConditionFieldEl = selectConditionField.rootEl.querySelector('.pickListField');
        selectConditionFieldEl.classList.add("conditionField");

        questionFieldEl.onmousedown = () => {
            const fieldValue = selectQuestionField.getValue();
            selectQuestionField.setData(this.getOptionsToQuestionField(fieldValue));
            selectQuestionField.setValue(fieldValue);
        };

        questionFieldEl.onchange = () => {
            const fieldValue = selectQuestionField.getValue();
            const question = Greenmile.Survey.Data.findQuestion(fieldValue);
            const questionType = question?.questionType || '';
            const questionId = question?.id || null;

            Greenmile.Survey.Data.updateSurveyActionCondition(actionId, id, { questionId, criteria: [] });
            selectConditionField.clear();

            switch (questionType) {
                case 'TEXT':
                    warningMessage.setAttribute('style', 'display:none');
                    selectConditionField.show();
                    selectConditionField.setData(textDomains)
                    break;
                case 'PICKLIST':
                case 'PICKLIST_MULTISELECT':
                    warningMessage.setAttribute('style', 'display:none');
                    selectConditionField.show();
                    selectConditionField.setData(pickListDomains)
                    break;
                default:
                    selectConditionField.hide();
                    warningMessage.setAttribute('style', 'display:block');
                    break;
            }
        };

        selectConditionFieldEl.onchange = () => {
            const questionFieldValue = selectQuestionField.getValue();
            const conditionFieldValue = selectConditionField.getValue();
            const question = Greenmile.Survey.Data.findQuestion(questionFieldValue);
            const questionId = question?.id || null;
            const domainlength = question?.surveyQuestionDomain?.length;

            const getCriteria = (condition) => {
                const criterias = {
                    TEXT_EMPTY: [{ eq: '' }],
                    ALL_OPTIONS_CHECKED: [{ eq: domainlength }],
                    SOME_OPTIONS_CHECKED: [{ lt: domainlength }],
                    DEFAULT: []
                };

                return criterias[condition] || criterias['DEFAULT'];
            };

            const criteria = getCriteria(conditionFieldValue);

            Greenmile.Survey.Data.updateSurveyActionCondition(actionId, id, { questionId, criteria });
        };

        const btnRemove = document.createElement('div');
        btnRemove.setAttribute('class', 'buttonRemove');
        btnRemove.innerHTML = '-';
        btnRemove.addEventListener('click', function () {
            const conditionItem = this.parentNode;

            Greenmile.Survey.Data.removeSurveyActionCondition(actionId, id);

            const parent = conditionItem.parentNode;
            parent.removeChild(conditionItem);
        });

        const btnAdd = document.createElement('div');
        btnAdd.setAttribute('class', 'buttonAdd');
        btnAdd.innerHTML = '+';

        btnAdd.addEventListener('click', () => {
            this.addActionCondition({ type: 'AND', parent, surveyAction: { id: actionId } })
        });


        const actionWidgetCondition = document.createElement('div');
        actionWidgetCondition.setAttribute('class', 'actionWidgetRow');
        actionWidgetCondition.setAttribute('condition-id', id);
        actionWidgetCondition.appendChild(actionWidgetConditionLabel);
        actionWidgetCondition.appendChild(selectQuestionField.rootEl);
        actionWidgetCondition.appendChild(selectConditionField.rootEl);
        actionWidgetCondition.appendChild(warningMessage);
        if (type) actionWidgetCondition.appendChild(btnRemove);
        actionWidgetCondition.appendChild(btnAdd);

        // set form data from server
        if (condition?.questionId) {
            selectQuestionField.setValue(`${condition.questionId}`);
            questionFieldEl.onchange();

            if (condition?.criteria) {
                const question = Greenmile.Survey.Data.findQuestion(condition.questionId);
                const questionType = question?.type;
                const criteria = condition?.criteria?.[0];
                const getOption = () => {
                    if (questionType === 'TEXT' && criteria?.eq === '') {
                        return 'TEXT_EMPTY';
                    }
                    if (questionType.includes('PICKLIST')) {
                        if (criteria?.eq) {
                            return 'ALL_OPTIONS_CHECKED';
                        }
                        if (criteria?.lt) {
                            return 'SOME_OPTIONS_CHECKED';
                        }
                    }
                    return '';
                };
                selectConditionField.setValue(getOption());
                selectConditionFieldEl.onchange();
            }
        }

        return actionWidgetCondition;
    },

    addActionCondition: function({ surveyAction, condition, type, parent }) {
        const id = condition?.id || Greenmile.Survey.Data.addSurveyActionCondition(surveyAction.id);
        const conditionWidget = Greenmile.Survey.Widgets.actionWidgetCondition({ id, type, parent, actionId: surveyAction.id, condition });
        parent.appendChild(conditionWidget);
    },

    prepareActionTitles: function(actionWidget, id) {
        const actionWidgetLabelTitle = actionWidget.querySelector('.actionWidgetLabelTitle');
        if (actionWidgetLabelTitle) {
            const order = Greenmile.Survey.Data.getSurveyActionOrderById(id);
            actionWidgetLabelTitle.innerHTML = Monet.I18n.translateResources("Survey.generateTask.ActionTitle", { order });
        }
    },

    removeAllActionsWidget: function () {
      document.querySelectorAll('.actionWidgetGroup').forEach(item => {
        const actionId = item.getAttribute('actionId');

        Greenmile.Survey.Data.removeSurveyActionById(actionId);
        item.remove();
      });
    },

    actionWidget: function(surveyAction) {
        const actionWidgetLabelTitle = document.createElement('label');
        actionWidgetLabelTitle.setAttribute('class', 'actionWidgetLabelTitle');

        const divTrash = document.createElement('div');
        divTrash.setAttribute('class', 'destroyGroup');
        divTrash.addEventListener('click', (e) => {

            const isToDelete = () => {
                const actionWidget = e.target.parentNode.parentNode;
                Greenmile.Survey.Data.removeSurveyActionById(surveyAction.id);

                const parent = actionWidget.parentNode;
                parent.removeChild(actionWidget);
                this.prepareActionTitles(actionWidget, surveyAction.id);
            };

            new Greenmile.Components.AlertModal('Greenmile.Survey.Confirm.DeleteItem',
                null,
                isToDelete)
            .show();
        });

        const actionWidgetHeader = document.createElement('div');
        actionWidgetHeader.className = "actionWidgetHeader";
        actionWidgetHeader.appendChild(actionWidgetLabelTitle);
        actionWidgetHeader.appendChild(divTrash);

        // Create conditions container with input rows
        const actionWidgetConditionContainer = document.createElement('div');
        actionWidgetConditionContainer.setAttribute('class', 'actionWidgetConditionContainer');
        if (surveyAction?.conditions?.length) {
            surveyAction.conditions.forEach((condition) => {
                this.addActionCondition({ parent: actionWidgetConditionContainer, surveyAction, condition });
            });
        } else {
            this.addActionCondition({ parent: actionWidgetConditionContainer, surveyAction });
        }

        // Create events and task container
        const eventFieldDomains = [ // temporary
            { value: '', description: Monet.I18n.getResourcesByKey('Survey.generateTask.field.selectEvent')},
            { value: 'GENERATE_TASK', description: Monet.I18n.getResourcesByKey('Survey.generateTask.field.todo.optionGenerateTask')},
        ];

        const actionWidgetEventContainer = document.createElement('div');
        actionWidgetEventContainer.setAttribute('class', 'actionWidgetEventContainer');

        // Create event type field
        const selectEventField = new Monet.UI.Fields.PickList();
        selectEventField.createElement();
        selectEventField.setTextLabel(Monet.I18n.getResourcesByKey('Survey.generateTask.field.label.todo'));
        selectEventField.rootEl.setAttribute("class", "MonetUIFieldPicker");
        selectEventField.rootEl.classList.add("eventField");
        selectEventField.setData(eventFieldDomains);
        actionWidgetEventContainer.appendChild(selectEventField.rootEl);

        // Create task type field
        const taskTypeField = new Monet.UI.Fields.Render({
            name: 'taskType',
            label: 'TaskType',
            lookupEntity: 'TaskType',
            lookupEntityColumn: 'description',
            type: 'LOOKUP'
        }, `SurveyAction${surveyAction.id}`).render();

        taskTypeField.afterCreateFilter = () => {
            taskTypeField.filter.changeCriteriaBeforeFilter = (criteria) => {
                const customCriteriaChain =
                    Greenmile.Survey.Data.getSurveyActionTaskTypeCriteriaChain().filter(
                        el => el.neq !== taskTypeField?.getValue()?.id
                    );
                const concatToCriteriaChain = (listOfCriterias) => {
                    criteria.criteriaChain[0].and =
                        criteria.criteriaChain[0].and.concat(listOfCriterias);
                };

                if (customCriteriaChain?.length) {
                    concatToCriteriaChain(customCriteriaChain);
                }

                concatToCriteriaChain([{ attr: "standardTaskTitle", isNull: false }]);

                return criteria;
            };
        };

        taskTypeField.rootEl.setAttribute("class", "MonetUIFieldPicker");
        taskTypeField.rootEl.classList.add("taskTypeField");
        taskTypeField.hide();
        actionWidgetEventContainer.appendChild(taskTypeField.rootEl);

        // Add event type onchange listener
        const eventFieldEl = selectEventField.rootEl.querySelector('.pickListField');
        eventFieldEl.onchange = () => {
            const fieldValue = selectEventField.getValue();
            if (fieldValue === 'GENERATE_TASK') {
                taskTypeField.show();
                Greenmile.Survey.Data.updateSurveyAction(surveyAction.id, { eventType: fieldValue });
            } else {
                taskTypeField.hide();
            }
        };

        // Add task type onchange listener
        taskTypeField.setOnChange(() => {
            Greenmile.Survey.Data.updateSurveyAction(surveyAction.id, { taskType: taskTypeField.getValue() || {} });
        });

        // Create widget content and group
        const actionWidgetContent = document.createElement('div');
        actionWidgetContent.setAttribute('class', 'actionWidgetContent');
        actionWidgetContent.appendChild(actionWidgetConditionContainer)
        actionWidgetContent.appendChild(actionWidgetEventContainer);

        const actionWidgetGroup = document.createElement('div');
        actionWidgetGroup.setAttribute('class', 'actionWidgetGroup');
        actionWidgetGroup.setAttribute('actionId', surveyAction.id);
        actionWidgetGroup.appendChild(actionWidgetHeader);
        actionWidgetGroup.appendChild(actionWidgetContent);

        // Set form data from server
        if (surveyAction?.eventType) {
            selectEventField.setValue(surveyAction.eventType);
            eventFieldEl.onchange();

            if (surveyAction?.taskType) {
                taskTypeField.setValue(surveyAction.taskType);
            }
        }

        return actionWidgetGroup;
    },

    getAddSubQuestionButton: function (parentQuestionId) {
        var buttonAddSubQuestions = new Monet.UI.Fields.Button();
        buttonAddSubQuestions.setValue(Monet.I18n.getResourcesByKey('Greenmile.Survey.AddSubQuestion'));
        buttonAddSubQuestions.rootEl.className += ' btnAddSubQuestions';
        buttonAddSubQuestions.addEventClickListener(function (scope, questionId) {
            return function (e) {
                scope.showModalToQuestion(e.target, questionId);
            };
        }(this, parentQuestionId));
        buttonAddSubQuestions.render();
        buttonAddSubQuestions.input.className = 'addItem';

        return buttonAddSubQuestions;
    },

    appendLinkElementToQuestion: function (questionContent, question) {

        var questionHeader = questionContent.querySelector('.newQuestionHeader');
        var questionLink = Greenmile.Survey.Widgets.questionLink(question);
        questionHeader.appendChild(questionLink);


        if (Greenmile.Survey.Builder.releasedDate) {

            questionLink.style.display = 'none';

        }

    },

    editLink: function (answer) {

        var edit = document.createElement('div');
        edit.className = 'editLink';
        edit.title = Monet.I18n.getResourcesByKey ('SmartSurvey.question.edit');

        edit.addEventListener('click', function () {

            Greenmile.Survey.Form.showEditOverlayForAnswer(answer);

        });

        return edit;
    },

    removeLink: function (answer) {

        var remove = document.createElement('div');
        remove.className = 'removeLink';
        remove.title = Monet.I18n.getResourcesByKey ('SmartSurvey.question.delete');

        remove.addEventListener('click', function () {

            Greenmile.Survey.Form.showRemoveOverlayForAnswer(answer);

        });

        return remove;
    },

    answerLink: function (answer, question) {

        var link = document.createElement('div');
        link.className = 'answerLink';
        link.title = Monet.I18n.getResourcesByKey ('SmartSurvey.question.jump');

        link.addEventListener('click', function () {

            Greenmile.Survey.Form.showLinkOverlayForAnswer(answer, question);

        });

        return link;
    },

    questionLink: function (question) {

        var link = document.createElement('div');
        link.className = 'questionLink';
        link.title = Monet.I18n.getResourcesByKey ('SmartSurvey.question.jump');

        link.addEventListener('click', function () {

            Greenmile.Survey.Form.showLinkOverlayForQuestion(question);

        });

        return link;
    },

    addMenu: function (questionId, sectionID, parentQuestionId) {

        var optionsMenu = {
            targetEl: '#Survey .newQuestionHeader input[question_id="' + questionId + '"]',
            addListenerToParent: true
        };

        var items = [],
            edit,
            deleteItem,
            reorder;

        edit = {
            id: 1,
            description: Monet.I18n.getResourcesByKey('Greenmile.Survey.Menu.edit'),
            icon: 'surveyEdit',
            action: function () {
                Greenmile.Survey.Sidebar.editQuestion(questionId, parentQuestionId);
            }
        };

        deleteItem = {
            id: 2,
            description: Monet.I18n.getResourcesByKey('Greenmile.Survey.Menu.delete'),
            icon: 'surveyDelete',
            action: function () {

                const isToDelete = () => {
                    let questions;
                    const questionContent = document.querySelector('#Survey .newQuestionContent[question_id="' + questionId + '"]');
                    let parent;

                    parent = questionContent.parentNode;
                    parent.removeChild(questionContent);

                    if (Greenmile.Survey.Form.linkedQuestions) {

                        var questionLinkedNotExcluded = Greenmile.Survey.Form.linkedQuestions.filter(function (element) {

                            var hasQuestionExcluded = element.link.value.toString() === questionId.toString() || element.questionId.toString() === questionId.toString();

                            return !hasQuestionExcluded;

                        });

                        $('.linkTag[link_question="' + questionId + '"]').remove();

                        Greenmile.Survey.Form.linkedQuestions = questionLinkedNotExcluded;

                    }

                    for (var i = 0, size = Greenmile.Survey.Data.surveyData.length; i < size; i++) {

                        questions = Greenmile.Survey.Data.surveyData[i].surveyQuestions;

                        //Remove link of questions that has jump to this question (that is being deleted)
                        questions.forEach(function (element) {

                            if (element.nextQuestion && element.nextQuestion.id.toString() === questionId.toString()) {
                                element.nextQuestion = null;
                            }

                        });

                        var questionInfo = Greenmile.Survey.Data.getQuestionById(questionId, questions);

                        if (questionInfo) {
                            Greenmile.Survey.Edit.deleteSurveyQuestion(questionId);
                            questions.splice(questionInfo.index, 1);

                            //If is subquestion, remove reference on parent question
                            if (questionInfo.question.parentQuestionId) {
                                var questionParent = Greenmile.Survey.Data.getQuestionById(questionInfo.question.parentQuestionId, questions);
                                var subQuestionsKeys = questionParent.question.subQuestions;
                                for (var k in subQuestionsKeys) {
                                    if (questionInfo.question.key === subQuestionsKeys[k].key) {
                                        subQuestionsKeys.splice(k, 1);
                                    }
                                }
                            }

                            //If question HAS subquestions, remove subquestions of data
                            var subquestions = questionInfo.question.subQuestions;
                            if (subquestions && subquestions.length) {
                                for (var j in subquestions) {
                                    var subQuestion = Greenmile.Survey.Data.getQuestionByAttribute('key', subquestions[j].key, questions);
                                    if (subQuestion) {
                                        questions.splice(subQuestion.index, 1);
                                    }
                                }
                            }

                            Greenmile.Survey.Form.verifyQuestionsToEnableActionButton();

                            return;
                        }

                    }

                    Greenmile.Survey.Form.verifyQuestionsToEnableActionButton();

                };

                new Greenmile.Components.AlertModal('Greenmile.Survey.Confirm.DeleteItem',
                    null,
                    isToDelete)
                .show();

            }.bind(this)

        };

        reorder = {
            id: 1,
            description: Monet.I18n.getResourcesByKey('Greenmile.Survey.Menu.reorder'),
            icon: 'surveyOrder',
            action: function () {
                Greenmile.Survey.Reorder.createDivToReorderQuestion(sectionID, parentQuestionId);
            }
        };

        items.push(edit);
        items.push(deleteItem);
        items.push(reorder);

        var menu = new Monet.UI.FloatMenu(null, optionsMenu);
        var optionsMenuList = new Monet.UI.List();

        optionsMenuList.itemRenderer = Monet.UI.ContentMenuItem;

        menu.listProvider = optionsMenuList;
        menu.menuItems = items;

        menu.removeAllMenus();
        menu.init();

        Greenmile.Survey.Widgets.menus = Greenmile.Survey.Widgets.menus || [];
        Greenmile.Survey.Widgets.menus.push(menu);

    },

    appendButtonsToAddQuestionAfterReleased: function (questionContent, questionId, questionData) {

        if (questionData.questionType === 'ENTITY') {

            var restriction = JSON.parse(questionData.entityRestriction);
            var crit = restriction.criteriaChain[0].and[0];
            if (crit && crit.attr !== 'id') {
                return false;
            }
        }

        var buttonNewItem = document.createElement('input');
        var resourceButtonNewItem = Monet.I18n.getResourcesByKey('Greenmile.Survey.Button.addNewItem');
        var lineSeparator = questionContent.querySelector('.lineSeparator');

        buttonNewItem.type = 'button';
        buttonNewItem.value = resourceButtonNewItem;

        var openPopupToAddNewItem = function () {
            var modal = new Greenmile.Survey.AddItemAfterReleased(questionData);
            modal.setQuestionId(questionId);
            modal.setQuestionType(questionContent.getAttribute('questionType'));
            modal.show();

        };

        buttonNewItem.addEventListener('click', openPopupToAddNewItem);
        questionContent.appendChild(buttonNewItem);
        questionContent.appendChild(lineSeparator);

    }

};
